import { useQuery } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { isEmpty } from 'underscore';
import Api from '../api/Api';
import { useSelectedDataset } from '../components/layout/Header/components/SearchBar';
import useAuthStore from '../store/authStore';
import useDatasetStore from '../store/datasetStore';
import useSearchStore from '../store/searchStore';
import { QUERY_KEYS } from './queryKeys';

export const useRegularDatasetBriefs = () => {
  const setDatasetBrief = useDatasetStore((state) => state.setDatasetBrief);

  return useQuery({
    queryKey: [QUERY_KEYS.dataset.datasetBriefs],
    queryFn: async () => {
      const res = await Api.search.dataSetBriefs({ includeGlobal: false });

      setDatasetBrief(res ?? []);

      return res;
    },
    enabled: Boolean(Api?.configData),
    retry: 3,
  });
};

export const useFWEDatasetBriefs = () => {
  const setFWEDatasetBrief = useDatasetStore(
    (state) => state.setFWEDatasetBrief
  );
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return useQuery({
    queryKey: [QUERY_KEYS.dataset.datasetBriefsFwe],
    queryFn: async () => {
      const res = await Api.search.dataSetBriefs({
        includeGlobal: false,
        vas: 'fwe',
      });

      setFWEDatasetBrief(res ?? []);

      return res;
    },
    enabled: isAuthenticated(),
  });
};

export const useInitDatasetBriefs = () => {
  const datasetBriefs = useDatasetStore((state) => state.datasetBriefs);
  const setDatasetBrief = useDatasetStore((state) => state.setDatasetBrief);

  const effectRan = useRef(false);
  const searchId = useSearchStore((state) => state.searchId);
  const { onChange } = useSelectedDataset();

  const regularDataQuery = useRegularDatasetBriefs();
  const fweDataQuery = useFWEDatasetBriefs();

  useEffect(() => {
    if (effectRan.current) return;
    if (isEmpty(searchId) || isEmpty(datasetBriefs)) return;

    onChange(searchId);
    effectRan.current = true;
  }, [searchId, datasetBriefs]);

  useEffect(() => {
    if (!regularDataQuery.data || !fweDataQuery.data) return;
    setDatasetBrief(regularDataQuery.data.concat(fweDataQuery.data));
  }, [regularDataQuery.data, fweDataQuery.data, setDatasetBrief]);
};
